const QueryKeys = {
  recapSessionByMeetKey: "recap-sessions-by-meet-key",
  recapRecordingsBySessionId: "recap-recordings-by-session-id",
  recapParticipantsBySessionId: "recap-participants-by-session-id",
  recapAbsenceBySessionId: "recap-absence-by-session-id",
  recapSummaryBySessionId: "recap-summary-by-session-id",
  recapTranscriptionBySessionId: "recap-transcription-by-session-id",
  recapKeypointsBySessionId: "recap-key-points-by-session-id",
  recapActionItemsBySessionId: "recap-actionItems-by-session-id",
  recapMeet: "recap-meet",
  recapOverviewBySessionId: "recap-overview-by-session-id",
  recapDecisionsBySessionId: "recap-decisions-by-session-id",
  recapMinutesBySessionId: "recap-minutes-by-session-id",
  recapSessionDataBySessionId: "recap-session-data-by-session-id",
  recapDecisionById: "recap-decision-by-id",
  recapActionItemById: "recap-actionItem-by-id",
};

export default QueryKeys;
